import gsap from "gsap";
import { SplitText } from "gsap/SplitText";
import FontFaceObserver from "fontfaceobserver";
var font = new FontFaceObserver("pprightmedium");
gsap.registerPlugin(SplitText);
// images scroll

function initHousing() {
  window.locoScroll.on("scroll", (args) => {
    if (typeof args.currentElements["housing"] === "object") {
      gsap.set(".housing__images", {
        y: -150 + args.currentElements["housing"].progress * 200 + "%",
      });
    }
  });

  let lines;
  font.load().then(() => {
    lines = new SplitText(".housing__text", {
      type: "lines",
      linesClass: "lineChild",
      lineThreshold: 1,
    });

    lines.lines.forEach((line, i) => {
      let spanWrap = document.createElement("span");
      spanWrap.classList.add("spanwrap");
      spanWrap.append(...line.childNodes);
      let copy = spanWrap.cloneNode(true);
      copy.classList.add("spancopy");
      line.append(spanWrap);
      line.append(copy);
      let mask = document.createElement("div");
      mask.classList.add("mask");
      // mask.append(...line.childNodes)
      line.setAttribute("data-scroll", true);
      line.setAttribute("data-scroll-offset", "20%");
      line.setAttribute("data-scroll-position", "top");
      line.setAttribute("data-scroll-class", "manifestLine");
      spanWrap.appendChild(mask);
    });
  });
}

if (document.querySelector(".housing")) {
  initHousing();
}
